import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Klassennamen zusammenführen.
 *
 * `twMerge` löst Konflikte zugunsten der später genannten Klasse auf: `cn("p-2",
 * "p-4")` ergibt `p-4` und nicht beides. Ohne das hinge das Ergebnis an der
 * Reihenfolge im erzeugten Stylesheet.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
